import React from 'react';

type Props = {
  onClick: () => void;
  title?: string;
};

const BackButton: React.FC<Props> = ({ onClick, title = 'بازگشت' }) => {
  return (
    <button
      onClick={onClick}
      className="absolute top-8 left-8 p-2 rounded-xl hover:bg-gray-100 text-gray-500 hover:text-[#0e444e] transition-all"
      title={title}
      aria-label={title}
      type="button"
    >
      <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
      </svg>
    </button>
  );
};

export default BackButton;
